import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { getResourceI18nNamespace } from "src/system/getResourceI18nNamespace.ts";

export const ResourceNotFound = ({ resource }: { resource: string }) => {
  const { t } = useTranslation();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        justify-content: center;
      `}
    >
      <h1
        css={css`
          margin-bottom: 0;
          margin-top: 0;
        `}
      >
        404!
      </h1>
      <div>
        {t(`oneNotFound`, "Record is not found", {
          ns: getResourceI18nNamespace(resource),
        })}
      </div>
    </div>
  );
};
